<template>
<el-container>
  <el-aside width="200px">
    <img src="@/assets/img/logo-white.svg" width="100%">
    <el-menu
      :default-active="section.index"
      background-color="#006ec7"
      text-color="#fff"
      active-text-color="#61bf1a">
        <el-submenu v-if="hasPermission('Orders', 'view')" index="1">
          <template slot="title">
            <i class="el-icon-truck"></i>
            <span>Pedidos</span>
          </template>
          <el-menu-item-group>
            <router-link :to="{ name: 'Orders' }">
              <el-menu-item index="1-1">Pedidos pendientes</el-menu-item>
            </router-link>
            <router-link v-if="hasPermission('OrdersCompleted', 'view')" :to="{ name: 'OrdersCompleted' }">
              <el-menu-item index="1-2">Pedidos realizados</el-menu-item>
            </router-link>
            <router-link v-if="hasPermission('OrdersAll', 'view')" :to="{ name: 'OrdersAll' }">
              <el-menu-item index="1-3">Todos los pedidos</el-menu-item>
            </router-link>
          </el-menu-item-group>
        </el-submenu>
      <router-link v-if="hasPermission('Users', 'view')" :to="{ name: 'Users' }">
        <el-menu-item index="2">
          <i class="el-icon-user"></i>
          <span>Generadores</span>
        </el-menu-item>
      </router-link>
      <router-link v-if="hasPermission('Zones', 'view')" :to="{ name: 'Zones' }">
        <el-menu-item index="3">
          <i class="el-icon-location-outline"></i>
          <span>Zonas</span>
        </el-menu-item>
      </router-link>
      <router-link v-if="hasPermission('Reminders', 'view')" :to="{ name: 'Reminders' }">
        <el-menu-item index="4">
          <i class="el-icon-notebook-2"></i>
          <span>Recordatorios</span>
        </el-menu-item>
      </router-link>
      <router-link v-if="hasPermission('Roles', 'view')" :to="{ name: 'Roles' }">
        <el-menu-item index="5">
          <i class="el-icon-unlock"></i>
          <span>Administradores</span>
        </el-menu-item>
      </router-link>
      <router-link v-if="hasPermission('Config', 'view')" :to="{ name: 'Config' }">
        <el-menu-item index="6">
          <i class="el-icon-setting"></i>
          <span>Configuración</span>
        </el-menu-item>
      </router-link>
    </el-menu>
  </el-aside>
  <el-container>
    <el-header>
      <div class="show-in-mobile">
        <el-dropdown style="float: left; line-height:60px">
          <span class="el-dropdown-link">
             <img src="@/assets/img/logo.svg" class="show-in-mobile" width="200px" style="margin-top:-5px">
          </span>
          <el-dropdown-menu slot="dropdown">
            
            <router-link v-if="hasPermission('Orders', 'view')" :to="{ name: 'Orders' }">
              <el-dropdown-item icon="el-icon-truck"> Pedidos pendientes</el-dropdown-item>
            </router-link>
            <router-link v-if="hasPermission('OrdersCompleted', 'view')" :to="{ name: 'OrdersCompleted' }">
              <el-dropdown-item icon="el-icon-truck"> Pedidos realizados</el-dropdown-item>
            </router-link>
            <router-link v-if="hasPermission('OrdersAll', 'view')" :to="{ name: 'OrdersAll' }">
              <el-dropdown-item icon="el-icon-truck"> Todos los Pedidos</el-dropdown-item>
            </router-link>
            <router-link v-if="hasPermission('Users', 'view')" :to="{ name: 'Users' }">
              <el-dropdown-item icon="el-icon-user"> Generadores</el-dropdown-item>
            </router-link>
            <router-link v-if="hasPermission('Zones', 'view')" :to="{ name: 'Zones' }">
              <el-dropdown-item icon="el-icon-location-outline"> Zonas</el-dropdown-item>
            </router-link>
            <router-link v-if="hasPermission('Reminders', 'view')" :to="{ name: 'Reminders' }">
              <el-dropdown-item icon="el-icon-notebook-2"> Recordatorios</el-dropdown-item>
            </router-link>
            <router-link v-if="hasPermission('Roles', 'view')" :to="{ name: 'Roles' }">
              <el-dropdown-item icon="el-icon-unlock"> Administradores</el-dropdown-item>
            </router-link>
            <router-link v-if="hasPermission('Config', 'view')" :to="{ name: 'Config' }">
              <el-dropdown-item icon="el-icon-setting"> Configuración</el-dropdown-item>
            </router-link>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <div class="hide-in-mobile" style="float:left; line-height:60px; margin-left:12px">
        {{ section.name }}
      </div>
      <el-dropdown style="float: right; line-height:60px">
      <span class="el-dropdown-link">
        {{current_user.displayName}}<i class="el-icon-arrow-down el-icon--right"></i>
      </span>
      <el-dropdown-menu slot="dropdown">
        <router-link :to="{ name: 'Profile' }">
          <el-dropdown-item icon="el-icon-edit">Editar Perfil</el-dropdown-item>
        </router-link>
        <router-link :to="{ name: 'Logout' }">
          <el-dropdown-item icon="el-icon-circle-close">Cerrar Sesión</el-dropdown-item>
        </router-link>
       </el-dropdown-menu>
    </el-dropdown>
     
    </el-header>
    <el-main><router-view :key="$route.fullPath" /></el-main>
  </el-container>
</el-container>
</template>

<script>
import firebase from 'firebase/app'
export default {
  created() {
    this.$store.commit('SET_CURRENT_USER', firebase.auth().currentUser)
  },
  computed: {
    section() {
      return this.$store.state.section
    },
    current_user() {
      return this.$store.state.current_user
    },
  },
  methods: {
    hasPermission( sectionName, permissionReq ) {
      return this.$store.getters.hasPermission(sectionName, permissionReq)
    }
  }
}
</script>

<style>
.el-table {
  border-radius: 5px;
  border: 1px solid #d8dbe0 !important;
}
.el-main {
  background-color: #ebedef !important;
  padding: 30px !important;
}
.el-menu a:visited {
  color: white !important;
}
.el-submenu__title {
  text-align: left !important;
  font-size: 16px;
}
.el-menu-item-group .el-menu-item {
    font-size: 14px !important;
    line-height: 50px;
}
.el-submenu .el-menu-item {
    height: 50px !important;
}
.el-aside {
  background-color: #006ec7;
  height: 100%;
}
.el-menu {
  border: none !important;
    text-align: left !important;
}
.el-container {
  height: 100vh;
}
.el-header {
  background-color:#fff !important;
  border-bottom: 1px solid #dadada;
}
.el-menu-item [class^=el-icon-] {
    font-size: 20px !important;
}
.el-menu-item, .el-submenu__title {
    height: 59px !important;
}
.el-footer {
    vertical-align: middle;
    line-height: 59px;
    background-color: #f1f1f1;
    margin-top: 20px;
}
.el-menu--horizontal .el-menu .el-menu-item {
  height: 36px !important;
  border-bottom: none !important;
  font-weight: 300;
  font-size: 14px !important;
}
.el-menu--horizontal .el-menu .el-menu-item span {
  margin-left: 5px;
}
.el-menu-item {
    font-size: 16px !important;
}
.el-menu-item-group__title {
    padding: 0
}
.el-menu-item i, .el-submenu__title i {
    color: #e3eff9 !important;
}
.el-menu-item.is-active i {
    color: #61bf1a !important;
}
.show-in-mobile {
  display: none;
}
.el-table .cell {
  word-break: break-word;
}

@media screen and (max-width: 900px) {
  .filter-col {
    margin-bottom: 10px;
    text-align: center;
  }
  .el-aside {
    display: none !important;
  }
  .show-in-mobile {
    display: block;
  }
  .hide-in-mobile {
    display: none;
  }
}
</style>
